import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNdd } from './pages'

type TIdToPageMapWoofzNdd = Record<PageIdWoofzNdd, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NDD: TIdToPageMapWoofzNdd = {
  [PageId.SUBSCRIPTIONS_NDD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/subscriptions/SubscriptionNdd65'
      ).then((m) => ({
        default: m.SubscriptionsNdd65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/subscriptions/SubscriptionNdd65'
      ),
  },
  [PageId.CANCEL_OFFER_NDD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/subscriptions/cancel-offer/CancelOfferNdd'
      ).then((m) => ({
        default: m.CancelOfferNdd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/subscriptions/cancel-offer/CancelOfferNdd'
      ),
  },
  [PageId.CHAT_UPSELL_NDD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NDD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/upsell/Upsell'),
  },
  [PageIdWoofzNdd.DOWNLOAD_NDD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNdd.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
